import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from "react";
import { LANDING_PAGE_URL } from "@/constants/links";
import { trackRegisterClick } from "@/lib/analytics";

type RegisterLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  section: string;
  label?: string;
  children: ReactNode;
};

export function RegisterLink({
  section,
  label,
  children,
  onClick,
  ...props
}: RegisterLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const clickLabel =
      label ??
      (typeof children === "string" ? children : undefined);

    trackRegisterClick(section, clickLabel);
    onClick?.(event);
  };

  return (
    <a href={LANDING_PAGE_URL} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
